export const chartConfig = {
  title: {
    text: 'Growth overview',
    left: 'center',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985',
      },
    },
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [
    {
      name: 'Portfolio value',
      type: 'line',
      stack: 'Total',
      areaStyle: {},
      color: '#60a5fa',
      emphasis: {
        focus: 'series',
      },
      data: [],
    },
  ],
};
